export default __webpack_public_path__ + "static/4-5da4f9507f163cedf07dff8c1ecbfefa.png";